import { useEffect, useState } from "react";
import { useApp } from "../../store.jsx";
import { Icon } from "../Common.jsx";
import { listProjects } from "../../lib/api";

// Compact dashboard widget: surfaces overdue active projects (server-computed
// `overdue`) with a jump into the module. Renders nothing if the tenant has no
// active projects, so it never adds noise for companies not using Projects.
export default function ProjectsAtRiskCard() {
  const { goPage } = useApp();
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    listProjects({ status: "active", limit: 100, sort: "deadline", dir: "asc" })
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data) return null;
  const active = data.projects || [];
  if (active.length === 0) return null;
  const overdue = active.filter((p) => p.overdue);

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-header">
        <div>
          <div className="card-title">Projects</div>
          <div className="card-subtitle">
            {active.length} active{overdue.length ? ` · ${overdue.length} overdue` : ""}
          </div>
        </div>
        <button
          type="button"
          onClick={() => goPage("projects")}
          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--primary-2)", fontSize: 13, fontWeight: 600 }}
        >
          View all →
        </button>
      </div>
      {overdue.length ? (
        overdue.slice(0, 4).map((p) => (
          <div
            key={p.id}
            className="activity-row"
            style={{ cursor: "pointer" }}
            onClick={() => goPage("projectDetail", { projectId: p.id })}
          >
            <Icon name="alert-triangle" size={16} style={{ color: "var(--error)", flexShrink: 0 }} />
            <div className="activity-text">
              <div className="activity-title" style={{ fontWeight: 600 }}>{p.name}</div>
              <div className="activity-meta">
                {p.taskCompleted}/{p.taskTotal} tasks · {p.progressPct}%
              </div>
            </div>
            <span className="badge badge-error" style={{ flexShrink: 0 }}>Overdue</span>
          </div>
        ))
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: 8, color: "var(--text-muted)", fontSize: 13, padding: "8px 0" }}>
          <Icon name="check-circle" size={16} style={{ color: "var(--success)" }} /> No overdue projects — nice.
        </div>
      )}
    </div>
  );
}
